module.exports = __webpack_public_path__ + "img/dashboard.1c6b17e7.png";